/* Bibi Abaya: search overlay + cart drawer */
(function () {
  if (window.__bbUi) return;
  window.__bbUi = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var money = function (cents) {
    var v = Math.round(cents) / 100;
    return '₹' + v.toLocaleString('en-IN', { maximumFractionDigits: v % 1 ? 2 : 0 });
  };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
  var lock = function (on) { document.documentElement.classList.toggle('bb-locked', on); };

  /* ------------------------------------------------------------ search */
  var search = $('#bb-search');
  if (search) {
    var input = $('input[type=search]', search);
    var out = $('[data-bb-search-results]', search);
    var idle = $('[data-bb-search-idle]', search);
    var timer, ctrl;
    var openSearch = function () {
      search.classList.add('is-open');
      search.setAttribute('aria-hidden', 'false');
      lock(true);
      setTimeout(function () { input.focus(); }, 120);
      showAll();
    };
    var closeSearch = function () {
      search.classList.remove('is-open');
      search.setAttribute('aria-hidden', 'true');
      lock(false);
    };
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-bb-search-open]');
      if (o) { e.preventDefault(); closeMenu(); openSearch(); return; }
      if (e.target.closest('[data-bb-search-close]') || e.target === $('.bb-search__scrim', search)) closeSearch();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSearch(); closeCart(); closeMenu(); } });
    var gridHtml = function (items) {
      return '<div class="bb-search__grid">' + items.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        return '<a class="bb-search__item" href="' + p.url + '"><span class="bb-search__img">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" loading="lazy">' : '') + '</span><span class="bb-search__name">' + esc(p.title) + '</span><span class="bb-search__price">' + money(parseFloat(p.price) * 100) + '</span></a>';
      }).join('') + '</div>';
    };
    // all products, shown when the box is empty (fetched once, only when search is opened)
    var allHtml = '', allBusy = false;
    var showAll = function () {
      if (input.value.trim()) return;
      if (allHtml) { out.innerHTML = allHtml; return; }
      if (allBusy) return;
      allBusy = true;
      fetch('/collections/all/products.json?limit=2')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.products || []).map(function (p) {
            var v = p.variants && p.variants[0];
            return { url: '/products/' + p.handle, title: p.title, price: v ? v.price : '0', image: p.images && p.images[0] ? p.images[0].src : '' };
          });
          allHtml = '<p class="bb-search__label">All products</p>' + gridHtml(items) + '<a class="bb-search__all" href="/collections/all">View all products &rarr;</a>';
          if (!input.value.trim()) out.innerHTML = allHtml;
        })
        .catch(function () {})
        .then(function () { allBusy = false; });
    };
    var render = function (items, q) {
      if (!items.length) {
        out.innerHTML = '<p class="bb-search__empty">No results for &ldquo;' + esc(q) + '&rdquo;. Try another word or browse <a href="/collections/all">all products</a>.</p>';
        return;
      }
      out.innerHTML = '<div class="bb-search__grid">' + items.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        return '<a class="bb-search__item" href="' + p.url + '"><span class="bb-search__img">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" loading="lazy">' : '') + '</span><span class="bb-search__name">' + esc(p.title) + '</span><span class="bb-search__price">' + money(parseFloat(p.price) * 100) + '</span></a>';
      }).join('') + '</div><a class="bb-search__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results &rarr;</a>';
    };
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 1) { idle.hidden = false; out.innerHTML = allHtml; showAll(); return; }
      idle.hidden = true;
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        out.innerHTML = '<p class="bb-search__empty">Searching&hellip;</p>';
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=2&resources[options][unavailable_products]=last', { signal: ctrl.signal })
          .then(function (r) { return r.json(); })
          .then(function (d) { render((d.resources && d.resources.results && d.resources.results.products) || [], q); })
          .catch(function (err) { if (err.name !== 'AbortError') out.innerHTML = ''; });
      }, 220);
    });
  }

  /* ------------------------------------------------------------ menu */
  var menu = $('#bb-menu');
  function openMenu() { if (!menu) return; menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); lock(true); }
  function closeMenu() { if (!menu || !menu.classList.contains('is-open')) return; menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); lock(false); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bb-menu-open]')) openMenu();
    else if (e.target.closest('[data-bb-menu-close]') || (menu && e.target.tagName === 'A' && menu.contains(e.target))) closeMenu();
  });

  /* ------------------------------------------------------------ cart */
  var cartEl = $('#bb-cart');
  var FREE = cartEl ? Number(cartEl.dataset.free || 0) : 0;
  function setCount(n) {
    document.querySelectorAll('[data-bb-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n < 1; });
    document.querySelectorAll('[data-bb-cart-label]').forEach(function (l) { l.textContent = n; });
  }
  function renderCart(cart) {
    if (!cartEl) return;
    setCount(cart.item_count);
    var body = $('[data-bb-cart-body]', cartEl);
    var foot = $('[data-bb-cart-foot]', cartEl);
    var bar = $('[data-bb-cart-ship]', cartEl);
    if (!cart.item_count) {
      body.innerHTML = '<div class="bb-cart__empty"><p>Your bag is empty.</p><a class="bb-btn" href="/collections/all">Start shopping</a></div>' + recsSlot();
      foot.hidden = true; bar.hidden = true; afterRender(cart); return;
    }
    foot.hidden = false;
    if (FREE > 0) {
      var left = FREE * 100 - cart.total_price;
      bar.hidden = false;
      bar.innerHTML = left > 0
        ? '<p>Add <b>' + money(left) + '</b> more for free shipping</p><i><u style="width:' + Math.min(100, cart.total_price / (FREE * 10)) + '%"></u></i>'
        : '<p><b>You have unlocked free shipping.</b></p><i><u style="width:100%"></u></i>';
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var opts = it.options_with_values.map(function (o) { return o.value; }).join(' / ');
      return '<div class="bb-cart__line" data-line="' + (i + 1) + '">' +
        '<a class="bb-cart__img" href="' + it.url + '">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '') + '</a>' +
        '<div class="bb-cart__info"><a class="bb-cart__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        '<p class="bb-cart__opts">' + esc(opts) + '</p>' +
        '<div class="bb-cart__row"><div class="bb-qty"><button type="button" data-qty="-1" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>' +
        '<b>' + money(it.final_line_price) + '</b></div></div>' +
        '<button type="button" class="bb-cart__rm" data-remove aria-label="Remove">&times;</button></div>';
    }).join('') + recsSlot();
    $('[data-bb-cart-total]', cartEl).textContent = money(cart.total_price);
    afterRender(cart);
  }
  /* ---- instant bag: the last known cart is kept in memory + sessionStorage and drawn before any network call ---- */
  var CACHE_KEY = 'bb-cart-v2';
  var lastSig = '';
  function sig(c) { return c.item_count + '|' + c.total_price + '|' + c.items.map(function (i) { return i.key + ':' + i.quantity; }).join(','); }
  function afterRender(cart) {
    lastSig = sig(cart);
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cart)); } catch (e) {}
    lastCart = cart; scheduleRecs(cart); requestAnimationFrame(recsArrows);
  }
  var lastCart = null, recTimer = 0;
  function scheduleRecs(cart) {
    if (cartEl.classList.contains('is-open')) return loadRecs(cart);
    clearTimeout(recTimer); recTimer = setTimeout(function () { loadRecs(cart); }, 2500);
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  // silent refresh: only redraws when something actually changed
  function refresh() {
    return fetchCart().then(function (c) { if (sig(c) !== lastSig) renderCart(c); else setCount(c.item_count); return c; });
  }
  function openCart() {
    if (!cartEl) { location.href = '/cart'; return; }
    closeMenu();
    cartEl.classList.add('is-open'); cartEl.setAttribute('aria-hidden', 'false'); lock(true);
    if (lastCart && !recsHtml) loadRecs(lastCart);
    refresh();
  }
  function closeCart() { if (!cartEl) return; cartEl.classList.remove('is-open', 'is-adding'); cartEl.setAttribute('aria-hidden', 'true'); lock(false); closeSheet(); }

  /* ---- "You may also like" inside the bag ---- */
  var recsHtml = '', recKey = '', recMap = {}, recCache = {};
  function recsSlot() { return '<div class="bb-cart__recs" data-bb-recs>' + recsHtml + '</div>'; }
  function toCents(v) { return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : (v || 0); }
  function normalise(p) {
    var vs = (p.variants || []).map(function (v) {
      var opts = v.options && v.options.length ? v.options : [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
      return { id: v.id, available: v.available !== false, price: toCents(v.price), compare: toCents(v.compare_at_price), options: opts };
    });
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var vals = names.map(function (n, i) { var seen = []; vs.forEach(function (v) { if (seen.indexOf(v.options[i]) < 0) seen.push(v.options[i]); }); return seen; });
    var img = p.featured_image && p.featured_image.src ? p.featured_image.src : (p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '');
    var av = vs.filter(function (v) { return v.available; });
    var from = vs.reduce(function (m, v) { return Math.min(m, v.price); }, 1e12);
    var first = av[0] || vs[0] || { price: 0, compare: 0 };
    return { handle: p.handle, title: p.title, url: '/products/' + p.handle, img: img, price: first.price, compare: first.compare > first.price ? first.compare : 0, variants: vs, names: names, values: vals, from: from, id: p.id };
  }
  function imgUrl(u) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=360'; }
  function buildRecs(list) {
    recMap = {};
    if (!list.length) { recsHtml = ''; return; }
    recsHtml = '<p class="bb-cart__recs-title">You may also like</p><div class="bb-cart__recs-wrap"><button type="button" class="bb-recs-arrow is-prev" data-recs-dir="-1" aria-label="Previous products" hidden><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button><div class="bb-cart__recs-row" data-bb-recs-row>' + list.map(function (p) {
      recMap[p.handle] = p;
      return '<div class="bb-rec">' +
        '<a class="bb-rec__img" href="' + p.url + '">' + (p.img ? '<img src="' + imgUrl(p.img) + '" alt="" loading="lazy" draggable="false">' : '') + '</a>' +
        '<a class="bb-rec__name" href="' + p.url + '">' + esc(p.title) + '</a>' +
        '<div class="bb-rec__price">' + (p.compare ? '<s>' + money(p.compare) + '</s> ' : '') + '<b>' + money(p.price) + '</b></div>' +
        '<button type="button" class="bb-rec__add" data-rec-add="' + esc(p.handle) + '">Add</button></div>';
    }).join('') + '</div><button type="button" class="bb-recs-arrow is-next" data-recs-dir="1" aria-label="More products"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button></div>';
  }
  function recsArrows() {
    var row = $('[data-bb-recs-row]', cartEl);
    if (!row) return;
    var prev = $('.bb-recs-arrow.is-prev', cartEl), next = $('.bb-recs-arrow.is-next', cartEl);
    if (prev) prev.hidden = row.scrollLeft < 8;
    if (next) next.hidden = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
  }
  function paintRecs() {
    var slot = $('[data-bb-recs]', cartEl);
    if (slot) slot.innerHTML = recsHtml;
    requestAnimationFrame(recsArrows);
  }
  function loadRecs(cart) {
    if (!cartEl) return;
    var pid = cart.items.length ? cart.items[0].product_id : 0;
    var key = String(pid);
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var finish = function (list) {
      list = list.filter(function (p) { return inCart.indexOf(p.id) < 0; }).slice(0, 8);
      buildRecs(list); recKey = key; paintRecs();
    };
    if (recCache[key]) { finish(recCache[key]); return; }
    var fallback = function () {
      return fetch('/collections/all/products.json?limit=12').then(function (r) { return r.json(); }).then(function (d) { return (d.products || []).map(normalise); });
    };
    var p = pid
      ? fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related').then(function (r) { return r.json(); }).then(function (d) { return (d.products || []).map(normalise); })
      : fallback();
    p.then(function (list) { return list.length >= 3 ? list : fallback().then(function (more) { return list.concat(more.filter(function (m) { return !list.some(function (l) { return l.id === m.id; }); })); }); })
      .then(function (list) { recCache[key] = list; finish(list); })
      .catch(function () {});
  }

  /* option picker for products that have sizes/colours */
  var sheet = null, sheetP = null, sheetSel = [];
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'bb-sheet'; sheet.hidden = true; sheet.setAttribute('data-bb-sheet', '');
    $('.bb-cart__panel', cartEl).appendChild(sheet);
    return sheet;
  }
  function sheetVariant() {
    return sheetP.variants.filter(function (v) { return sheetSel.every(function (s, i) { return v.options[i] === s; }); })[0];
  }
  function paintSheet() {
    var v = sheetVariant();
    sheet.querySelectorAll('[data-sheet-opt]').forEach(function (b) {
      var i = Number(b.dataset.group), val = b.dataset.value;
      b.classList.toggle('is-on', sheetSel[i] === val);
      var test = sheetSel.slice(); test[i] = val;
      var ok = sheetP.variants.some(function (x) { return x.available && test.every(function (s, k) { return x.options[k] === s; }); });
      b.classList.toggle('is-out', !ok);
    });
    var btn = $('[data-sheet-add]', sheet);
    btn.disabled = !v || !v.available;
    btn.textContent = !v ? 'Unavailable' : (v.available ? 'Add to bag' : 'Sold out');
    $('[data-sheet-price]', sheet).innerHTML = v ? ((v.compare > v.price ? '<s>' + money(v.compare) + '</s> ' : '') + '<b>' + money(v.price) + '</b>') : '';
  }
  function openSheet(p) {
    ensureSheet();
    sheetP = p;
    var av = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    sheetSel = av ? av.options.slice() : [];
    sheet.innerHTML = '<div class="bb-sheet__bar"><b>' + esc(p.title) + '</b><button type="button" class="bb-cart__x" data-sheet-close aria-label="Close">&times;</button></div>' +
      p.names.map(function (n, i) {
        return '<p class="bb-sheet__label">' + esc(n) + '</p><div class="bb-sheet__chips">' + p.values[i].map(function (val) {
          return '<button type="button" class="bb-sheet__chip" data-sheet-opt data-group="' + i + '" data-value="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('') + '</div>';
      }).join('') +
      '<div class="bb-sheet__foot"><span data-sheet-price></span><button type="button" class="bb-btn" data-sheet-add>Add to bag</button></div>';
    sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    paintSheet();
  }
  function closeSheet() { if (!sheet) return; sheet.classList.remove('is-open'); sheet.hidden = true; }
  function addVariant(id, btn) {
    var old = btn.textContent; btn.disabled = true; btn.textContent = 'Adding';
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Could not add'); return d; }); })
      .then(function () { closeSheet(); return fetchCart().then(renderCart); })
      .catch(function () { btn.textContent = 'Try again'; setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 1400); return null; })
      .then(function () { if (btn.isConnected && btn.textContent === 'Adding') { btn.textContent = old; btn.disabled = false; } });
  }

  window.bibiCart = {
    open: openCart, close: closeCart, refresh: refresh,
    add: function (form) {
      // open the bag straight away with a loading bar, then fill it as soon as the item is in
      if (cartEl) { cartEl.classList.add('is-adding'); openCart(); }
      return fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag'); return d; }); })
        .then(function () { return fetchCart(); })
        .then(function (c) { renderCart(c); if (cartEl) cartEl.classList.remove('is-adding'); if (!cartEl) location.href = '/cart'; })
        .catch(function (err) { if (cartEl) { cartEl.classList.remove('is-adding'); closeCart(); } throw err; });
    }
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-bb-cart-open]');
    if (o && cartEl) { e.preventDefault(); openCart(); return; }
    if (!cartEl) return;
    var recArrow = e.target.closest('[data-recs-dir]');
    if (recArrow) { var rr = $('[data-bb-recs-row]', cartEl); if (rr) rr.scrollBy({ left: Number(recArrow.dataset.recsDir) * Math.max(160, rr.clientWidth * 0.75), behavior: 'smooth' }); return; }
    var recAdd = e.target.closest('[data-rec-add]');
    if (recAdd) { var rp = recMap[recAdd.dataset.recAdd]; if (!rp) return; if (rp.variants.length === 1) addVariant(rp.variants[0].id, recAdd); else openSheet(rp); return; }
    if (e.target.closest('[data-sheet-close]')) { closeSheet(); return; }
    var sOpt = e.target.closest('[data-sheet-opt]');
    if (sOpt) { sheetSel[Number(sOpt.dataset.group)] = sOpt.dataset.value; paintSheet(); return; }
    var sAdd = e.target.closest('[data-sheet-add]');
    if (sAdd) { var sv = sheetVariant(); if (sv && sv.available) addVariant(sv.id, sAdd); return; }
    if (e.target.closest('[data-bb-cart-close]')) { closeCart(); return; }
    var line = e.target.closest('.bb-cart__line');
    if (!line) return;
    var n = Number(line.dataset.line);
    var qtyBtn = e.target.closest('[data-qty]');
    var cur = Number($('.bb-qty span', line).textContent);
    var next = null;
    if (qtyBtn) next = cur + Number(qtyBtn.dataset.qty);
    if (e.target.closest('[data-remove]')) next = 0;
    if (next === null) return;
    line.classList.add('is-busy');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: n, quantity: Math.max(0, next) }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  });
  if (cartEl) {
    cartEl.addEventListener('scroll', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-bb-recs-row')) recsArrows(); }, true);
    // draw the last known bag right away, then confirm with the server
    try { var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); if (cached && cached.items) renderCart(cached); } catch (e) {}
    fetchCart().then(function (c) { if (sig(c) !== lastSig) renderCart(c); else setCount(c.item_count); });
  }
})();
